import React from 'react';
import PropTypes from 'prop-types';

import StyledMicrobit, { Device, Front, Back } from './Microbit.styles';

const Microbit = ({accelerometer}) => (
	<StyledMicrobit>
		<Device accelerometer={accelerometer}>
			<Front />
			<Back />
		</Device>
	</StyledMicrobit>
);

Microbit.propTypes = {
	accelerometer: PropTypes.shape({
		x: PropTypes.number,
		y: PropTypes.number,
		z: PropTypes.number,
		roll: PropTypes.number,
		pitch: PropTypes.number,
	}),
};

Microbit.defaultProps = {
	accelerometer: {
		x: 10,
		y: 10,
		z: 10,
	},
};

export default Microbit;



// WEBPACK FOOTER //
// ./src/components/Microbit/Microbit.js